import RevokeLicenseModal from './RevokeLicenseModal';

export default RevokeLicenseModal;
